
export const GET_PATIENT_TABLE = 'GET_PATIENT_TABLE'
export const GET_PATIENT_TABLE_REQUEST = 'GET_PATIENT_TABLE_REQUEST'
export const GET_PATIENT_TABLE_SUCCESS = 'GET_PATIENT_TABLE_SUCCESS'
export const GET_PATIENT_TABLE_FAILURE = 'GET_PATIENT_TABLE_FAILURE'


export const GET_PATIENT_GRAPH = 'GET_PATIENT_GRAPH'
export const GET_PATIENT_GRAPH_REQUEST = 'GET_PATIENT_GRAPH_REQUEST'
export const GET_PATIENT_GRAPH_SUCCESS = 'GET_PATIENT_GRAPH_SUCCESS'
export const GET_PATIENT_GRAPH_FAILURE = 'GET_PATIENT_GRAPH_FAILURE'

export const getPatientGraphRequest = (data) => ({ type: GET_PATIENT_GRAPH_REQUEST, data })
export const getPatientGraphSuccess = (data) => ({ type: GET_PATIENT_GRAPH_SUCCESS, data })
export const getPatientGraphFailure = (error) => ({ type: GET_PATIENT_GRAPH_FAILURE, payload: error })


export const GET_PATIENT = 'GET_PATIENT'
export const GET_PATIENT_REQUEST = 'GET_PATIENT_REQUEST'
export const GET_PATIENT_SUCCESS = 'GET_PATIENT_SUCCESS'
export const GET_PATIENT_FAILURE = 'GET_PATIENT_FAILURE'


export const getPatientRequest = (payload) => ({ type: GET_PATIENT_REQUEST, payload })
export const getPatientSuccess = (data) => ({ type: GET_PATIENT_SUCCESS, data })
export const getPatientFailure = (error) => ({ type: GET_PATIENT_FAILURE, payload: error })


export const GET_PATIENT_DETAIL = 'GET_PATIENT_DETAIL'
export const GET_PATIENT_DETAIL_REQUEST = 'GET_PATIENT_DETAIL_REQUEST'
export const GET_PATIENT_DETAIL_SUCCESS = 'GET_PATIENT_DETAIL_SUCCESS'
export const GET_PATIENT_DETAIL_FAILURE = 'GET_PATIENT_DETAIL_FAILURE'


export const getPatientDetailsRequest = (payload) => ({ type: GET_PATIENT_DETAIL_REQUEST, payload })
export const getPatientDetailsSuccess = (data) => ({ type: GET_PATIENT_DETAIL_SUCCESS, data })
export const getPatientDetailsFailure = (error) => ({ type: GET_PATIENT_DETAIL_FAILURE, payload: error })


export const DELETE_APPOINTMENT_REQUEST = 'DELETE_APPOINTMENT_REQUEST'

export const deleteAppointmentRequest = (payload) => ({ type: DELETE_APPOINTMENT_REQUEST, payload })


export const GET_MEDICAL_HISTORY = 'GET_MEDICAL_HISTORY'
export const GET_MEDICAL_HISTORY_REQUEST = 'GET_MEDICAL_HISTORY_REQUEST'
export const GET_MEDICAL_HISTORY_SUCCESS = 'GET_MEDICAL_HISTORY_SUCCESS'
export const GET_MEDICAL_HISTORY_FAILURE = 'GET_MEDICAL_HISTORY_FAILURE'


export const getMedicalHistoryRequest = (payload) => ({ type: GET_MEDICAL_HISTORY_REQUEST, payload })
export const getMedicalHistorySuccess = (data) => ({ type: GET_MEDICAL_HISTORY_SUCCESS, data })
export const getMedicalHistoryFailure = (error) => ({ type: GET_MEDICAL_HISTORY_FAILURE, payload: error })

export const POST_MEDICAL_HISTORY = 'POST_MEDICAL_HISTORY'
export const POST_MEDICAL_HISTORY_REQUEST = 'POST_MEDICAL_HISTORY_REQUEST'
export const POST_MEDICAL_HISTORY_SUCCESS = 'POST_MEDICAL_HISTORY_SUCCESS'
export const POST_MEDICAL_HISTORY_FAILURE = 'POST_MEDICAL_HISTORY_FAILURE'


export const postMedicalHistoryRequest = (payload) => ({ type: POST_MEDICAL_HISTORY_REQUEST, payload })
export const postMedicalHistorySuccess = (data) => ({ type: POST_MEDICAL_HISTORY_SUCCESS, data })
export const postMedicalHistoryFailure = (error) => ({ type: POST_MEDICAL_HISTORY_FAILURE, payload: error })


export const PUT_MEDICAL_HISTORY = 'PUT_MEDICAL_HISTORY'
export const PUT_MEDICAL_HISTORY_REQUEST = 'PUT_MEDICAL_HISTORY_REQUEST'
export const PUT_MEDICAL_HISTORY_SUCCESS = 'PUT_MEDICAL_HISTORY_SUCCESS'
export const PUT_MEDICAL_HISTORY_FAILURE = 'PUT_MEDICAL_HISTORY_FAILURE'


export const putMedicalHistoryRequest = (payload) => ({ type: PUT_MEDICAL_HISTORY_REQUEST, payload })
export const putMedicalHistorySuccess = (data) => ({ type: PUT_MEDICAL_HISTORY_SUCCESS, data })
export const putMedicalHistoryFailure = (error) => ({ type: PUT_MEDICAL_HISTORY_FAILURE, payload: error })

export const GET_CONTACT_INFORMATION = 'GET_CONTACT_INFORMATION'
export const GET_CONTACT_INFORMATION_REQUEST = 'GET_CONTACT_INFORMATION_REQUEST'
export const GET_CONTACT_INFORMATION_SUCCESS = 'GET_CONTACT_INFORMATION_SUCCESS'
export const GET_CONTACT_INFORMATION_FAILURE = 'GET_CONTACT_INFORMATION_FAILURE'


export const getContactInformationRequest = (payload) => ({ type: GET_CONTACT_INFORMATION_REQUEST, payload })
export const getContactInformationSuccess = (data) => ({ type: GET_CONTACT_INFORMATION_SUCCESS, data })
export const getContactInformationFailure = (error) => ({ type: GET_CONTACT_INFORMATION_FAILURE, payload: error })


export const POST_CONTACT_INFORMATION = 'POST_CONTACT_INFORMATION'
export const POST_CONTACT_INFORMATION_REQUEST = 'POST_CONTACT_INFORMATION_REQUEST'
export const POST_CONTACT_INFORMATION_SUCCESS = 'POST_CONTACT_INFORMATION_SUCCESS'
export const POST_CONTACT_INFORMATION_FAILURE = 'POST_CONTACT_INFORMATION_FAILURE'


export const postContactInformationRequest = (payload) => ({ type: POST_CONTACT_INFORMATION_REQUEST, payload })
export const postContactInformationSuccess = (data) => ({ type: POST_CONTACT_INFORMATION_SUCCESS, data })
export const postContactInformationFailure = (error) => ({ type: POST_CONTACT_INFORMATION_FAILURE, payload: error })


export const PUT_CONTACT_INFORMATION = 'PUT_CONTACT_INFORMATION'
export const PUT_CONTACT_INFORMATION_REQUEST = 'PUT_CONTACT_INFORMATION_REQUEST'
export const PUT_CONTACT_INFORMATION_SUCCESS = 'PUT_CONTACT_INFORMATION_SUCCESS'
export const PUT_CONTACT_INFORMATION_FAILURE = 'PUT_CONTACT_INFORMATION_FAILURE'


export const putContactInformationRequest = (payload) => ({ type: PUT_CONTACT_INFORMATION_REQUEST, payload })
export const putContactInformationSuccess = (data) => ({ type: PUT_CONTACT_INFORMATION_SUCCESS, data })
export const putContactInformationFailure = (error) => ({ type: PUT_CONTACT_INFORMATION_FAILURE, payload: error })


export const POST_REFERAL_INFORMATION = 'POST_REFERAL_INFORMATION'
export const POST_REFERAL_INFORMATION_REQUEST = 'POST_REFERAL_INFORMATION_REQUEST'
export const POST_REFERAL_INFORMATION_SUCCESS = 'POST_REFERAL_INFORMATION_SUCCESS'
export const POST_REFERAL_INFORMATION_FAILURE = 'POST_REFERAL_INFORMATION_FAILURE'


export const postReferalInformationRequest = (payload) => ({ type: POST_REFERAL_INFORMATION_REQUEST, payload })
export const postReferalInformationSuccess = (data) => ({ type: POST_REFERAL_INFORMATION_SUCCESS, data })
export const postReferalInformationFailure = (error) => ({ type: POST_REFERAL_INFORMATION_FAILURE, payload: error })


export const GET_REFERAL_INFORMATION = 'GET_REFERAL_INFORMATION'
export const GET_REFERAL_INFORMATION_REQUEST = 'GET_REFERAL_INFORMATION_REQUEST'
export const GET_REFERAL_INFORMATION_SUCCESS = 'GET_REFERAL_INFORMATION_SUCCESS'
export const GET_REFERAL_INFORMATION_FAILURE = 'GET_REFERAL_INFORMATION_FAILURE'


export const getReferalInformationRequest = (payload) => ({ type: GET_REFERAL_INFORMATION_REQUEST, payload })
export const getReferalInformationSuccess = (data) => ({ type: GET_REFERAL_INFORMATION_SUCCESS, data })
export const getReferalInformationFailure = (error) => ({ type: GET_REFERAL_INFORMATION_FAILURE, payload: error })


export const PUT_REFERAL_INFORMATION = 'PUT_REFERAL_INFORMATION'
export const PUT_REFERAL_INFORMATION_REQUEST = 'PUT_REFERAL_INFORMATION_REQUEST'
export const PUT_REFERAL_INFORMATION_SUCCESS = 'PUT_REFERAL_INFORMATION_SUCCESS'
export const PUT_REFERAL_INFORMATION_FAILURE = 'PUT_REFERAL_INFORMATION_FAILURE'


export const putReferalInformationRequest = (payload) => ({ type: PUT_REFERAL_INFORMATION_REQUEST, payload })
export const putReferalInformationSuccess = (data) => ({ type: PUT_REFERAL_INFORMATION_SUCCESS, data })
export const putReferalInformationFailure = (error) => ({ type: PUT_REFERAL_INFORMATION_FAILURE, payload: error })



export const GET_APPOINTMENT = 'GET_APPOINTMENT'
export const GET_APPOINTMENT_REQUEST = 'GET_APPOINTMENT_REQUEST'
export const GET_APPOINTMENT_SUCCESS = 'GET_APPOINTMENT_SUCCESS'
export const GET_APPOINTMENT_FAILURE = 'GET_APPOINTMENT_FAILURE'


export const getAppointmentRequest = (payload) => ({ type: GET_APPOINTMENT_REQUEST, payload })
export const getAppointmentSuccess = (data) => ({ type: GET_APPOINTMENT_SUCCESS, data })
export const getAppointmentFailure = (error) => ({ type: GET_APPOINTMENT_FAILURE, payload: error })


export const GET_ALL_APPOINTMENT = 'GET_ALL_APPOINTMENT'
export const GET_ALL_APPOINTMENT_REQUEST = 'GET_ALL_APPOINTMENT_REQUEST'
export const GET_ALL_APPOINTMENT_SUCCESS = 'GET_ALL_APPOINTMENT_SUCCESS'
export const GET_ALL_APPOINTMENT_FAILURE = 'GET_ALL_APPOINTMENT_FAILURE'


export const getAllAppointmentRequest = (payload) => ({ type: GET_ALL_APPOINTMENT_REQUEST, payload })
export const getAllAppointmentSuccess = (data) => ({ type: GET_ALL_APPOINTMENT_SUCCESS, data })
export const getAllAppointmentFailure = (error) => ({ type: GET_ALL_APPOINTMENT_FAILURE, payload: error })

export const APPEND_APPOINTMENT_LIST = 'APPEND_APPOINTMENT_LIST'

export const appendAppointmentList = (data) => ({ type: APPEND_APPOINTMENT_LIST, data })

export const GET_APPOINTMENT_LENGTH = "GET_APPOINTMENT_LENGTH"

export const getAppointmentLength = (data) => ({ type: GET_APPOINTMENT_LENGTH, data })

export const POST_APPOINTNET = 'POST_APPOINTNET'
export const POST_APPOINTNET_REQUEST = 'POST_APPOINTNET_REQUEST'
export const POST_APPOINTNET_SUCCESS = 'POST_APPOINTNET_SUCCESS'
export const POST_APPOINTNET_FAILURE = 'POST_APPOINTNET_FAILURE'


export const postAppointmentRequest = (payload) => ({ type: POST_APPOINTNET_REQUEST, payload })
export const postAppointmentSuccess = (payload) => ({ type: POST_APPOINTNET_SUCCESS, payload })
export const postAppointmentFailure = (error) => ({ type: POST_APPOINTNET_FAILURE, payload: error })


export const PUT_APPOINTNET = 'PUT_APPOINTNET'
export const PUT_APPOINTNET_REQUEST = 'PUT_APPOINTNET_REQUEST'
export const PUT_APPOINTNET_SUCCESS = 'PUT_APPOINTNET_SUCCESS'
export const PUT_APPOINTNET_FAILURE = 'PUT_APPOINTNET_FAILURE'


export const putAppointmentRequest = (payload) => ({ type: PUT_APPOINTNET_REQUEST, payload })
export const putAppointmentSuccess = (payload) => ({ type: PUT_APPOINTNET_SUCCESS, payload })
export const putAppointmentFailure = (error) => ({ type: PUT_APPOINTNET_FAILURE, payload: error })

export const GET_SCHEDULE_DEVICE = 'GET_SCHEDULE_DEVICE'
export const GET_SCHEDULE_DEVICE_REQUEST = 'GET_SCHEDULE_DEVICE_REQUEST'
export const GET_SCHEDULE_DEVICE_SUCCESS = 'GET_SCHEDULE_DEVICE_SUCCESS'
export const GET_SCHEDULE_DEVICE_FAILURE = 'GET_SCHEDULE_DEVICE_FAILURE'


export const getScheduleDeviceRequest = (payload) => ({ type: GET_SCHEDULE_DEVICE_REQUEST, payload })
export const getScheduleDeviceSuccess = (payload) => ({ type: GET_SCHEDULE_DEVICE_SUCCESS, payload })
export const getScheduleDeviceFailure = (error) => ({ type: GET_SCHEDULE_DEVICE_FAILURE, payload: error })

export const POST_SCHEDULE_DEVICE = 'POST_SCHEDULE_DEVICE'
export const POST_SCHEDULE_DEVICE_REQUEST = 'POST_SCHEDULE_DEVICE_REQUEST'
export const POST_SCHEDULE_DEVICE_SUCCESS = 'POST_SCHEDULE_DEVICE_SUCCESS'
export const POST_SCHEDULE_DEVICE_FAILURE = 'POST_SCHEDULE_DEVICE_FAILURE'


export const postScheduleDeviceRequest = (payload) => ({ type: POST_SCHEDULE_DEVICE_REQUEST, payload })
export const postScheduleDeviceSuccess = (payload) => ({ type: POST_SCHEDULE_DEVICE_SUCCESS, payload })
export const postScheduleDeviceFailure = (error) => ({ type: POST_SCHEDULE_DEVICE_FAILURE, payload: error })


export const POST_PATIENT = 'POST_PATIENT'
export const POST_PATIENT_REQUEST = 'POST_PATIENT_REQUEST'
export const POST_PATIENT_SUCCESS = 'POST_PATIENT_SUCCESS'
export const POST_PATIENT_FAILURE = 'POST_PATIENT_FAILURE'


export const postPatientRequest = (payload) => ({ type: POST_PATIENT_REQUEST, payload })
export const postPatientSuccess = (data) => ({ type: POST_PATIENT_SUCCESS, data })
export const postPatientFailure = (error) => ({ type: POST_PATIENT_FAILURE, payload: error })


export const PUT_PATIENT = 'PUT_PATIENT'
export const PUT_PATIENT_REQUEST = 'PUT_PATIENT_REQUEST'
export const PUT_PATIENT_SUCCESS = 'PUT_PATIENT_SUCCESS'
export const PUT_PATIENT_FAILURE = 'PUT_PATIENT_FAILURE'


export const putPatientRequest = (payload) => ({ type: PUT_PATIENT_REQUEST, payload })
export const putPatientSuccess = (data) => ({ type: PUT_PATIENT_SUCCESS, data })
export const putPatientFailure = (error) => ({ type: PUT_PATIENT_FAILURE, payload: error })


export const DELETE_PATIENT_REQUEST = 'DELETE_PATIENT_REQUEST'

export const deletePatientRequest = (payload) => ({ type: DELETE_PATIENT_REQUEST, payload })


export const GET_ACTIVE_STUDY = 'GET_ACTIVE_STUDY'
export const GET_ACTIVE_STUDY_REQUEST = 'GET_ACTIVE_STUDY_REQUEST'
export const GET_ACTIVE_STUDY_SUCCESS = 'GET_ACTIVE_STUDY_SUCCESS'
export const GET_ACTIVE_STUDY_FAILURE = 'GET_ACTIVE_STUDY_FAILURE'


export const getActiveStudyRequest = (payload) => ({ type: GET_ACTIVE_STUDY_REQUEST, payload })
export const getActiveStudySuccess = (payload) => ({ type: GET_ACTIVE_STUDY_SUCCESS, payload })
export const getActiveStudyFailure = (error) => ({ type: GET_ACTIVE_STUDY_FAILURE, payload: error })


export const GET_DETAIL_STUDY = 'GET_DETAIL_STUDY'
export const GET_DETAIL_STUDY_REQUEST = 'GET_DETAIL_STUDY_REQUEST'
export const GET_DETAIL_STUDY_SUCCESS = 'GET_DETAIL_STUDY_SUCCESS'
export const GET_DETAIL_STUDY_FAILURE = 'GET_DETAIL_STUDY_FAILURE'


export const getDetailStudyRequest = (payload) => ({ type: GET_DETAIL_STUDY_REQUEST, payload })
export const getDetailStudySuccess = (payload) => ({ type: GET_DETAIL_STUDY_SUCCESS, payload })
export const getDetailStudyFailure = (error) => ({ type: GET_DETAIL_STUDY_FAILURE, payload: error })


export const GET_HEART_BEAT_STUDY = 'GET_HEART_BEAT_STUDY'
export const GET_HEART_BEAT_STUDY_REQUEST = 'GET_HEART_BEAT_STUDY_REQUEST'
export const GET_HEART_BEAT_STUDY_SUCCESS = 'GET_HEART_BEAT_STUDY_SUCCESS'
export const GET_HEART_BEAT_STUDY_FAILURE = 'GET_HEART_BEAT_STUDY_FAILURE'


export const getHeartBeatRequest = (payload) => ({ type: GET_HEART_BEAT_STUDY_REQUEST, payload })
export const getHeartBeatSuccess = (payload) => ({ type: GET_HEART_BEAT_STUDY_SUCCESS, payload })
export const getHeartBeatFailure = (error) => ({ type: GET_HEART_BEAT_STUDY_FAILURE, payload: error })

export const GET_PER_FACILITY = 'GET_PER_FACILITY'
export const GET_PER_FACILITY_REQUEST = 'GET_PER_FACILITY_REQUEST'
export const GET_PER_FACILITY_SUCCESS = 'GET_PER_FACILITY_SUCCESS'
export const GET_PER_FACILITY_FAILURE = 'GET_PER_FACILITY_FAILURE'

export const getPerFacilityRequest = (payload) => ({ type: GET_PER_FACILITY_REQUEST, payload })
export const getPerFacilitySuccess = (payload) => ({ type: GET_PER_FACILITY_SUCCESS, payload })
export const getPerFacilityFailure = (error) => ({ type: GET_PER_FACILITY_FAILURE, payload: error })


export const GET_SECURED_HEART_BEAT_STUDY = 'GET_SECURED_HEART_BEAT_STUDY'
export const GET_SECURED_HEART_BEAT_STUDY_REQUEST = 'GET_SECURED_HEART_BEAT_STUDY_REQUEST'
export const GET_SECURED_HEART_BEAT_STUDY_SUCCESS = 'GET_SECURED_HEART_BEAT_STUDY_SUCCESS'
export const GET_SECURED_HEART_BEAT_STUDY_FAILURE = 'GET_SECURED_HEART_BEAT_STUDY_FAILURE'


export const getSecuredHeartBeatRequest = (payload) => ({ type: GET_SECURED_HEART_BEAT_STUDY_REQUEST, payload })
export const getSecuredHeartBeatSuccess = (payload) => ({ type: GET_SECURED_HEART_BEAT_STUDY_SUCCESS, payload })
export const getSecuredHeartBeatFailure = (error) => ({ type: GET_SECURED_HEART_BEAT_STUDY_FAILURE, payload: error })

export const GET_UTLIZATION_SECURED_HEART_BEAT_STUDY = 'GET_UTLIZATION_SECURED_HEART_BEAT_STUDY'
export const GET_UTLIZATION_SECURED_HEART_BEAT_STUDY_REQUEST = 'GET_UTLIZATION_SECURED_HEART_BEAT_STUDY_REQUEST'
export const GET_UTLIZATION_SECURED_HEART_BEAT_STUDY_SUCCESS = 'GET_UTLIZATION_SECURED_HEART_BEAT_STUDY_SUCCESS'
export const GET_UTLIZATION_SECURED_HEART_BEAT_STUDY_FAILURE = 'GET_UTLIZATION_SECURED_HEART_BEAT_STUDY_FAILURE'


export const getUtilizationSecuredHeartBeatRequest = (payload) => ({ type: GET_UTLIZATION_SECURED_HEART_BEAT_STUDY_REQUEST, payload })
export const getUtilizationSecuredHeartBeatSuccess = (payload) => ({ type: GET_UTLIZATION_SECURED_HEART_BEAT_STUDY_SUCCESS, payload })
export const getUtilizationSecuredHeartBeatFailure = (error) => ({ type: GET_UTLIZATION_SECURED_HEART_BEAT_STUDY_FAILURE, payload: error })


export const GET_UTLIZATION_CHART_RATES_STUDY = 'GET_UTLIZATION_CHART_RATES'
export const GET_UTLIZATION_CHART_RATES_REQUEST = 'GET_UTLIZATION_CHART_RATES_REQUEST'
export const GET_UTLIZATION_CHART_RATES_SUCCESS = 'GET_UTLIZATION_CHART_RATES_SUCCESS'
export const GET_UTLIZATION_CHART_RATES_FAILURE = 'GET_UTLIZATION_CHART_RATES_FAILURE'


export const getUtilizationChartRatesRequest = (payload) => ({ type: GET_UTLIZATION_CHART_RATES_REQUEST, payload })
export const getUtilizationChartRatesSuccess = (payload) => ({ type: GET_UTLIZATION_CHART_RATES_SUCCESS, payload })
export const getUtilizationChartRatesFailure = (error) => ({ type: GET_UTLIZATION_CHART_RATES_FAILURE, payload: error })


export const GET_UTLIZATION_RATES_STUDY = 'GET_UTLIZATION_RATES_STUDY'
export const GET_UTLIZATION_RATES_STUDY_REQUEST = 'GET_UTLIZATION_RATES_STUDY_REQUEST'
export const GET_UTLIZATION_RATES_STUDY_SUCCESS = 'GET_UTLIZATION_RATES_STUDY_SUCCESS'
export const GET_UTLIZATION_RATES_STUDY_FAILURE = 'GET_UTLIZATION_RATES_STUDY_FAILURE'


export const getUtilizationRatesStudyRequest = (payload) => ({ type: GET_UTLIZATION_RATES_STUDY_REQUEST, payload })
export const getUtilizationRatesStudySuccess = (payload) => ({ type: GET_UTLIZATION_RATES_STUDY_SUCCESS, payload })
export const getUtilizationRatesStudyFailure = (error) => ({ type: GET_UTLIZATION_RATES_STUDY_FAILURE, payload: error })


export const GET_UTLIZATION_RATES_PROCEDURE = 'GET_UTLIZATION_RATES_PROCEDURE'
export const GET_UTLIZATION_RATES_PROCEDURE_REQUEST = 'GET_UTLIZATION_RATES_PROCEDURE_REQUEST'
export const GET_UTLIZATION_RATES_PROCEDURE_SUCCESS = 'GET_UTLIZATION_RATES_PROCEDURE_SUCCESS'
export const GET_UTLIZATION_RATES_PROCEDURE_FAILURE = 'GET_UTLIZATION_RATES_PROCEDURE_FAILURE'


export const getUtilizationRatesProcedureRequest = (payload) => ({ type: GET_UTLIZATION_RATES_PROCEDURE_REQUEST, payload })
export const getUtilizationRatesProcedureSuccess = (payload) => ({ type: GET_UTLIZATION_RATES_PROCEDURE_SUCCESS, payload })
export const getUtilizationRatesProcedureFailure = (error) => ({ type: GET_UTLIZATION_RATES_PROCEDURE_FAILURE, payload: error })

export const GET_UTLIZATION_RATES_PROCEDURE_CHART = 'GET_UTLIZATION_RATES_PROCEDURE_CHART'
export const GET_UTLIZATION_RATES_PROCEDURE_CHART_REQUEST = 'GET_UTLIZATION_RATES_PROCEDURE_CHART_REQUEST'
export const GET_UTLIZATION_RATES_PROCEDURE_CHART_SUCCESS = 'GET_UTLIZATION_RATES_PROCEDURE_CHART_SUCCESS'
export const GET_UTLIZATION_RATES_PROCEDURE_CHART_FAILURE = 'GET_UTLIZATION_RATES_PROCEDURE_CHART_FAILURE'


export const getUtilizationRatesProcedureChartRequest = (payload) => ({ type: GET_UTLIZATION_RATES_PROCEDURE_CHART_REQUEST, payload })
export const getUtilizationRatesProcedureChartSuccess = (payload) => ({ type: GET_UTLIZATION_RATES_PROCEDURE_CHART_SUCCESS, payload })
export const getUtilizationRatesProcedureChartFailure = (error) => ({ type: GET_UTLIZATION_RATES_PROCEDURE_CHART_FAILURE, payload: error })


export const GET_MODALITY_OPTIONS = 'GET_MODALITY_OPTIONS'

export const getModalityOptions = (payload) => ({ type: GET_MODALITY_OPTIONS, payload })


export const GET_DEVICES_OPTIONS = 'GET_DEVICES_OPTIONS'

export const getDevicesOptions = (payload) => ({ type: GET_DEVICES_OPTIONS, payload })